import React, {
  useCallback,
  useMemo,
  useState,
  useEffect,
  useRef,
} from "react";
import { Text, Image, TouchableOpacity, View, FlatList } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import NoDataFound from "../NoDataFound";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";
import { AppScreens } from "../../screens/Utility/AppScreens";
import GameSkeleton from "../skeleton-components/GameSkeleton";

export default function SearchGameComponent({
  styles,
  eventsResult,
  eventsResultEmpty,
  heading,
  showLoader,
}) {
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();

  const flatListRef = useRef(null);
  const [popularIndex, setPopularIndex] = useState(0);

  const arrGames = useMemo(
    () =>
      eventsResult.map((game) => ({
        title: game.gameTitle,
        source: game.image,
      })),
    [eventsResult]
  );

  useEffect(() => {
    if (arrGames.length > 0) {
      flatListRef.current?.scrollToIndex({
        index: popularIndex,
        animated: true,
        viewPosition: 0,
      });
    }
  }, [popularIndex, arrGames]);

  const handleNextPress = () => {
    if (popularIndex < arrGames.length - 1) {
      setPopularIndex(popularIndex + 1);
    }
  };

  const handlePrevPress = () => {
    if (popularIndex > 0) {
      setPopularIndex(popularIndex - 1);
    }
  };

  return (
    <View
      style={{
        paddingTop: 12,
        gap: 25,
      }}
    >
      <Text
        style={[
          AppFontStyle.BOLD_ANYBODY_16,
          {
            color: AppColors.white,
            marginTop: 10,
            fontWeight: 800,
          },
        ]}
      >
        {heading}
      </Text>
      {showLoader ? (
        <GameSkeleton />
      ) : (
        <View
          style={{
            marginVertical: 14,
            gap: 5,
          }}
        >
          {eventsResultEmpty ? (
            <NoDataFound />
          ) : (
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              {deviceSize === DEVICE_SIZES.SM ||
              deviceSize === DEVICE_SIZES.XS ? null : (
                <TouchableOpacity
                  activeOpacity={0.5}
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onPress={handlePrevPress}
                >
                  <Ionicons
                    name="arrow-back"
                    size={35}
                    color={AppColors.white}
                  />
                </TouchableOpacity>
              )}
              <FlatList
                ref={flatListRef}
                data={arrGames}
                horizontal
                scrollEnabled
                showsHorizontalScrollIndicator={false}
                keyExtractor={(item, index) => String(item.title)}
                renderItem={({ item, index }) => {
                  return (
                    <TouchableOpacity
                      style={[
                        {
                          // marginBottom: 10,
                          alignItems: "center",
                        },
                      ]}
                      activeOpacity={0.8}
                      onPress={() => {
                        navigateToScreen(navigation, AppScreens.SearchGameWebScreen, {
                            game: item.title,
                          });
                      }}
                    >
                      <View
                        style={[
                          {
                            // borderWidth: 3,
                            // borderColor: AppColors.green_4CD964,
                            // borderRadius: 25,
                            overflow: "hidden",
                            width: 115,
                          },
                        ]}
                      >
                        <Image
                          source={item.source}
                          style={{
                            width: 110,
                            height: 128,
                            borderRadius: 25,
                          }}
                          resizeMode="cover"
                        />
                      </View>
                      <Text
                        style={[
                          AppFontStyle.MEDIUM_ANYBODY_12,
                          {
                            color: AppColors.white,
                            marginTop: 10,
                            width: 100,
                            textAlign: "center",
                          },
                        ]}
                      >
                        {item.title}
                      </Text>
                    </TouchableOpacity>
                  );
                }}
                ItemSeparatorComponent={() => <View style={{ width: 30 }} />}
              />
              {deviceSize === DEVICE_SIZES.SM ||
              deviceSize === DEVICE_SIZES.XS ? null : (
                <TouchableOpacity
                  activeOpacity={0.5}
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onPress={handleNextPress}
                >
                  <Ionicons
                    name="arrow-forward"
                    size={35}
                    color={AppColors.white}
                  />
                </TouchableOpacity>
              )}
            </View>
          )}
        </View>
      )}
    </View>
  );
}
